var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-smile",
    clipPath: "url(#clip0_2_8994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66669 11.6667C6.66669 11.6667 7.91669 13.3333 10 13.3333C12.0834 13.3333 13.3334 11.6667 13.3334 11.6667M12.5 7.49999H12.5084M7.50002 7.49999H7.50835M18.3334 9.99999C18.3334 14.6024 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 9.99999C1.66669 5.39762 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 9.99999ZM12.9167 7.49999C12.9167 7.73011 12.7301 7.91666 12.5 7.91666C12.2699 7.91666 12.0834 7.73011 12.0834 7.49999C12.0834 7.26987 12.2699 7.08332 12.5 7.08332C12.7301 7.08332 12.9167 7.26987 12.9167 7.49999ZM7.91669 7.49999C7.91669 7.73011 7.73014 7.91666 7.50002 7.91666C7.2699 7.91666 7.08335 7.73011 7.08335 7.49999C7.08335 7.26987 7.2699 7.08332 7.50002 7.08332C7.73014 7.08332 7.91669 7.26987 7.91669 7.49999Z",
    stroke: "#175CD3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/asset-4.171557531b4c028a3f55a95d99eefe8f.svg";
export { ForwardRef as ReactComponent };